import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalPropertiesService } from "services/ClientPortalPropertiesService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  PropertySelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const PropertySelectSlice = createSlice({
  name: "PropertySelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPropertySelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getPropertySelectModels.rejected, (state) => {
        state.PropertySelectModels = new Array<GuidSelectModel>();
        state.Loading = false;
        state.LastUpdateTime = new Date();
      })
      .addCase(getPropertySelectModels.fulfilled, (state, action) => {
        state.PropertySelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getPropertySelectModels = createAsyncThunk("PropertySelect/GetSelectModels", async () => {
  const propertiesService = container.get<IClientPortalPropertiesService>(SERVICE_TYPES.ClientPortalPropertiesService);
  return await propertiesService.getPropertySelectModels();
});

export const selectPropertySelectModels = (state: RootState) => state.propertySelect.PropertySelectModels;
export const selectLoadingPropertySelectModels = (state: RootState) => state.propertySelect.Loading;
export const selectLastUpdateTime = (state: RootState) => state.propertySelect.LastUpdateTime;

export default PropertySelectSlice.reducer;
